import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Heading, ISingleChoiceButtonOption, SingleChoice } from '@ruby-labs/ui-core-kit';

import { BaseContext } from 'context/base.context';
import { RoutePath } from 'routes/route-path.constant';

import { useSaveAnswers } from 'hooks/use-save-answers.hook';
import { useLocalStorage } from 'hooks/use-local-storage.hook';

import { LocalStorageKeys } from 'constants/local-storage';

export enum WORKOUTS_ANSWERS { NOT = 'notAtAll', ONE = 'oneTwo', THREE = 'three', MORE = 'moreThanThree' }

export const Workouts = () => {
    const { t } = useTranslation();
    const saveAnswers = useSaveAnswers();

    const { pageConfiguration } = useContext(BaseContext);

    const pageKey = LocalStorageKeys[RoutePath.Workouts];

    const { pageValue, setPageValue }: any = useLocalStorage({
        key: pageKey,
        defaultValue: '',
    });

    const handleClick = (option: ISingleChoiceButtonOption) => {
        saveAnswers({
            key: pageKey,
            itemQuestion: { question: t('workouts-title'), value: option.label },
        });
        setPageValue(option);

        pageConfiguration.handleOnPageComplete(option.value);
    };

    const options: ISingleChoiceButtonOption[] = [
        { value: WORKOUTS_ANSWERS.NOT, label: t('workouts-option-notAtAll') },
        { value: WORKOUTS_ANSWERS.ONE, label: t('workouts-option-oneTwo') },
        { value: WORKOUTS_ANSWERS.THREE, label: t('workouts-option-three') },
        { value: WORKOUTS_ANSWERS.MORE, label: t('workouts-option-moreThanThree') },
    ];

    return (
        <>
            <Heading title={t('workouts-title')} />

            <SingleChoice
                options={options}
                selectedOption={pageValue}
                onSelect={handleClick} />
        </>
    );
};
